import Termly from 'termly-namespace'

import CookieConsents, {
  CONSENT_LIFETIME_SECONDS,
} from 'utils/cookieConsents'

import isCookiePolicyVersionUpdated from './isCookiePolicyVersionUpdated'


export default function shouldRenderReminder({ cookiePolicy }) {
  if ( !cookiePolicy ) {
    return false
  }

  if ( Termly.tcf?.isConsentableContentVersionChanged ) {
    return true
  }

  return ( isCookieConsentExpired() || isCookiePolicyVersionUpdated(cookiePolicy) )
}

function isCookieConsentExpired() {
  return ( !CookieConsents.getConsents(CONSENT_LIFETIME_SECONDS) )
}
